export default __webpack_public_path__ + "static/media/part_3_con_02.1793cdfd.gif";